import { useMutation } from "@tanstack/react-query";

import { deleteAccount } from "@/api";
import { useLogout } from "@/hooks";
import { useUIStore } from "stores/ui.store";

const useDeleteAccount = () => {
  const { logout } = useLogout();

  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: () => {
      return deleteAccount();
    },
    onSuccess: async () => {
      logout();
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useDeleteAccount };
